module.exports = __webpack_public_path__ + "html/force-change.template.html";